import { Box } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import Icon from 'ui/Element/Icon'

/**
 * Cell styles
 * @returns {{root: {width: string, height: string}}}
 */
const styles = () => ({
  root: {
    width: '2.5rem',
    height: '2.5rem',
  },
})

/**
 * Displays the icon of a notification
 *
 * @param {Object} classes  styles for the component
 * @param {Object} props    props for the component
 * @returns {JSX.Element}
 */
const ListItemCellNotificationIcon = (classes, props = {}) => {
  const { type, group } = props

  const iconName = ((group === 'alert') && 'document')
      || ((group === 'message') && 'mail')
      || ''

  return (
    <Box className={classes.root}>
      <Icon
        name={iconName}
        iconPadding={'0.5rem'}
        color={'black'}
        background={'gray.960'}
        shape={'circle'}
      />
    </Box>
  )
}

export default CellHOC(ListItemCellNotificationIcon, styles)
